import * as languageTypes from './languageTypes';
import { LANGUAGES } from '../../../../constants/constants';

const getValueFromLanguage = value => {
  const lang = sessionStorage.getItem('language');
  if (lang) {
    return JSON.parse(lang)[value];
  }
};

const initialState = {
  selectedLocale: {
    code: getValueFromLanguage('code') || LANGUAGES.EN_US,
    value: getValueFromLanguage('value') || LANGUAGES.EN_US.slice(0, 2),
  },
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case languageTypes.SET_NEW_LOCALE:
      return {
        ...state,
        selectedLocale: {
          code: action.code,
          value: action.value,
        },
      };

    default:
      return state;
  }
};

export default languageReducer;
